export default "__VITE_ASSET__Bylaah41__"